import type { FieldArrayWithId } from "react-hook-form";

import { useState } from "react";
import { TooltipTrigger } from "react-aria-components";

import { Button } from "@/components/button";
import { useMediaPreviewModal } from "@/components/media-preview-modal/useMediaPreviewModal.tsx";
import { Tooltip } from "@/components/tooltip";

import type { UploadFilesFormData } from "../schema";

import { FILE_ICONS } from "../../../assets/file-icons";

export function FileItemPreview({
  field,
}: {
  field: FieldArrayWithId<UploadFilesFormData, "files", "id">;
}) {
  const [isError, setIsError] = useState(false);
  const { originalName } = field;
  const extension = originalName.split(".").pop()?.toLowerCase() || "";
  const IconComponent =
    extension in FILE_ICONS
      ? FILE_ICONS[extension as keyof typeof FILE_ICONS]
      : FILE_ICONS.fallback;

  const fileUrl = URL.createObjectURL(field.file);

  const { openModal } = useMediaPreviewModal();

  return (
    <div className="size-[84px] rounded-md grid place-items-center bg-bg-secondary overflow-hidden border border-border-tertiary">
      <TooltipTrigger delay={0}>
        <Button
          aria-label="Scope help"
          className="h-min cursor-default"
          onPress={() => {
            openModal(String(field.attachmentId));
          }}
          variant="unstyled"
        >
          {isError ? (
            <IconComponent />
          ) : (
            <img
              alt={originalName}
              className="size-full object-cover"
              onError={() => setIsError(true)}
              src={fileUrl}
            />
          )}
        </Button>
        <Tooltip>{field.name}</Tooltip>
      </TooltipTrigger>
    </div>
  );
}
